module.exports = __webpack_public_path__ + "img/email.69e04832.svg";